import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appFormActions]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppFormActionsDirective {
  class = input<string>();

  #base = 'flex gap-2 p-4';

  public styles = computed(() => {
    return cn(this.#base, this.class());
  });
}
